import * as Yup from 'yup';

export const createPackUsersSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required('Email is required'),
    // role:Yup.string().required('Please select role')
});
